import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { VipOnboardingComponent } from './components/vip-onboarding.component'

export const routes: Routes = [
  {
    path: '',
    component: VipOnboardingComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class VipOnboardingRoutingModule {}
